<template lang="pug">
  .challenge-include-teams
    BCollapse.card(
      aria-id="teamsTable"
      :open.sync="open"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='teamsTable'
      )
        .card-header-title
          | {{ title }}
          WtTooltip(
            v-if="tooltipText"
            :text="tooltipText"
            position="is-right"
          )
        a.card-header-icon
          BIcon(:icon="open ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .card-content
        .teams-tables
          TeamsTable(
            :key="includeByType"
            :loading="!loaded"
            mode="api"
            :enable-search="true"
            :search-fields="['name']"
            :enable-add="true"
            title="All Teams:"
            :empty-message="loaded && 'Awaiting teams ...' || ''"
            :includeByType="includeByType"
            :notInChallengeId="notInChallengeId"
            :emptyMessage="emptyMessage"
          )
          .level
          TeamsTable.mt-6(
            mode="receiver"
            :enable-remove="true"
            :title="receiverTitle"
            :empty-message="loaded && 'Awaiting teams ...' || ''"
          )
</template>

<script>
import WtTooltip from "@@/WtTooltip/WtTooltip";
import TeamsTable from "@@/ChallengeBuilder/ChallengeBuilderTeamsTable";

export default {
  name: "ChallengeIncludeTeams",

  components: { WtTooltip, TeamsTable },

  props: {
    openToggle: {
      type: Boolean,
      required: true
    },

    loaded: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      default: "Invite Teams"
    },

    tooltipText: {
      type: String,
      default: ""
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    notInChallengeId: {
      type: Number,
      default: 0
    },

    emptyMessage: {
      type: String,
      default: "No teams have been added yet"
    }
  },

  data() {
    return {
      open: this.openToggle
    };
  },

  computed: {
    receiverTitle() {
      const textByType = {
        invite: "Teams To Be Invited",
        add: "Teams To Be Added"
      };

      return this._.get(textByType, this.includeByType, "Future Teams");
    }
  },

  watch: {
    open() {
      this.$emit("toggle", this.open);
    },

    openToggle() {
      return (this.open = this.openToggle);
    }
  }
};
</script>

<style scoped lang="sass">
.challenge-include-teams
  .teams-tables
    width: 100%
    min-height: 550px
</style>
